<template>
  <div>
    <div class="form-container for-first-login" id="m_login">
      <div class="login-body-container">
        <div v-if="!requiredPasswordExpired" class="document-logo-container">
          <CompanyLogo />
        </div>

        <div v-if="launchEmailValidation">
          <div class="row login-normal-container mfa-text">
            <div class="col-lg-6 col-md-6 flex justify-center">
              <mfa-template>
                <template v-slot:svg>
                  <div class="mfa-logo-email-validation"></div>
                </template>
                <template v-slot:header>
                  <div class="mfa-main-title">
                    {{ $t("message.mfa.email_validation.title") }}
                  </div>
                </template>
                <template v-slot:subtitle>
                  <p class="mfa-description">
                    <span v-if="emailValidationEmpty">{{
                      $t("message.mfa.email_validation.sub_title_email_empty")
                    }}</span>
                    <span v-else>{{
                      $t("message.mfa.email_validation.sub_title_email_dirty")
                    }}</span>
                  </p>
                </template>
                <template v-slot:form>
                  <div class="mb-5">
                    <form>
                      <zt-input
                        label="Email"
                        v-model="emailValidation"
                        v-validate="'required|email'"
                        data-vv-name="email"
                        data-vs-input="input-login-email-validation"
                      />
                      <div
                        class="form-control-feedback m--font-danger"
                        v-show="errors.has('email')"
                      >
                        {{ errors.first("email") }}
                      </div>
                    </form>
                  </div>
                </template>
                <template v-slot:submitButtons>
                  <div class="flex justify-between">
                    <div class="w-1/2 mr-4">
                      <zt-button
                        outlined
                        class="text-zt-lg w-full mb-2"
                        data-vs-button="button-login-required-mfa"
                        @click="hiddenRequiredMFA"
                        style="color: #4f41a3 !important"
                        >{{
                          $t("message.mfa.email_validation.go_back_btn")
                        }}</zt-button
                      >
                    </div>
                    <div class="w-1/2">
                      <zt-button
                        v-if="buttonSendEnabled"
                        data-vs-button="buton-login-send-email-validation"
                        @click="submitEmailValidation"
                        :disabled="errors.any()"
                        type="submit"
                        class="text-zt-lg w-full mb-2"
                        >{{
                          $t("message.mfa.email_validation.send_btn")
                        }}</zt-button
                      >
                      <zt-button
                        v-else
                        data-vs-button="buton-login-cancel-validation"
                        :disabled="true"
                        class="text-zt-lg w-full mb-2"
                        >{{
                          $t("message.mfa.email_validation.sending_btn")
                        }}</zt-button
                      >
                    </div>
                  </div>
                </template>
              </mfa-template>
            </div>
            <div
              id="imageBackground"
              class="col-lg-6 col-md-6 flex justify-center"
            >
              <div v-if="$browserDetect.isChrome" class="logo-desktop"></div>
              <div v-else>
                <img
                  :src="`${baseUrl}assets/images/background-login.png`"
                  class="logo-desktop-noChrome"
                />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="
            !forgetpass &&
              !firstlogin &&
              !requiredMFA &&
              !launchEmailValidation &&
              !showMessageExceededFails &&
              !requiredPasswordExpired
          "
        >
          <AuthLogin
            @clickForgetPass="changeForgetPass"
            @firstLogin="changeFirstLogin"
            @firstLoginToken="getFirstLoginToken"
            @firstLoginEmail="getFirstLoginEmail"
            @passwordPolicies="getPasswordPolicies"
            @usersRelated="getUsersRelated"
            @user="getUser"
            @password="getPassword"
            @jwt="getJwt"
            @requiredValidationMFA="getRequiredValidationMFA"
            @launchEmailValidation="setLaunchEmailValidation"
            @loginEmailValidation="getLoginEmailValidation"
            @exceededFailsAuth="exceededFailsAuthMFA"
            @passwordExpired="passwordExpired"
          />
        </div>
        <div v-if="requiredMFA">
          <mfa-auth
            :jwt="this.jwt"
            :username="username"
            :password="password"
            :isFromLogin="isFromLogin"
            :user-email="emailValidation"
            @usersRelated="getUsersRelated"
            @exceededFailsAuth="exceededFailsAuthMFA"
            @backToLogin="hiddenRequiredMFA"
          />
        </div>
        <div v-if="requiredPasswordExpired">
          <PasswordExpiredTemplate
            @backToLogin="hiddenPasswordExpiredTemplate"
            :lastPassword="password"
          />
        </div>
        <div v-if="showMessageExceededFails">
          <mfa-message-exceeded-fails
            :isMaxResendFails="isMaxResendFails"
            @backToLogin="hiddenRequiredMFA"
          />
        </div>
        <div v-if="forgetpass">
          <ForgetPassword @clickAuthLogin="changeForgetPass" />
        </div>
        <div v-if="firstlogin">
          <FirstLogin
            @clickAuthLogin="changeFirstLogin"
            :token="firstLoginToken"
            :email="firstLoginEmail"
            :policies="PasswordPolicies"
          />
        </div>
      </div>
    </div>
    <FooterLogin :versionSichern="getVersion()" />
    <!--<div v-show="userHasMoreProfiles">
      <SwitchUser
        ref="modalRelated"
        :usersinfo="usersRelated"
        :title="this.$t('message.login.title_switch')"
        parentComponent="Login"
        :namebtnbubmit="this.$t('message.login.name_btn_switch')"
        showOnlyAdmin="true"
        @switch="onSwitch"
        @closeModal="closeModalAndSession"
      />
    </div>-->
    <ModalHelp />
  </div>
</template>

<script>
import { Vue } from "vue-property-decorator";
import swal from "sweetalert2";
import Alert from "../../components/generics/Alert.vue";
import FooterLogin from "@/components/login/FooterLogin.vue";
import ModalHelp from "@/components/login/ModalHelp.vue";
import CompanyLogo from "@/components/login/CompanyLogo.vue";
import AuthLogin from "@/components/login/Auth.vue";
import ForgetPassword from "@/components/login/ForgetPassword.vue";
import FirstLogin from "@/components/login/FirstLogin.vue";
import { mapGetters } from "vuex";
import _ from "lodash";
import SwitchLogin from "../menu/header-top/switch-user/SwitchLogin.vue";
import SwitchUser from "../menu/header-top/switch-user/SwitchUser.vue";
import User from "../../apiClient/User";
import MfaClient from "../../apiClient/Mfa";
import Actions from "../../apiClient/Actions";
import mfaTemplate from "@/components/login/mfa/mfaTemplate.vue";
import axios from "axios";
import VersionSichern from "!!raw-loader!../../../../../../config/version.txt";
import MfaAuth from "@/components/login/mfa/mfaAuth";
import MfaMessageExceededFails from "@/components/login/mfa/mfaMessageExceededFails";
import MfaTemplate from "@/components/login/mfa/mfaTemplate";

import PasswordExpiredTemplate from "@/components/login/passwordExpired/PasswordExpiredTemplate";
import Auth from "@/apiClient/Auth";
export default {
  components: {
    MfaTemplate,
    MfaMessageExceededFails,
    MfaAuth,
    Alert,
    FooterLogin,
    ModalHelp,
    SwitchLogin,
    SwitchUser,
    ForgetPassword,
    FirstLogin,
    AuthLogin,
    CompanyLogo,
    PasswordExpiredTemplate,
  },
  data() {
    return {
      EMPLOYEE_PROFILE: 1,
      ADMIN_PROFILE: 2,
      firstLoginToken: "",
      firstLoginEmail: "",
      PasswordPolicies: {},
      username: "",
      password: "",
      jwt: "",
      firstlogin: false,
      forgetpass: false,
      alertMoment: true,
      userHasMoreProfiles: false,
      launchEmailValidation: false,
      buttonSendEnabled: true,
      emailValidation: "",
      emailValidationEmpty: false,
      usersRelated: [],
      isFromLogin: true,
      $refs: {
        alert: HTMLElement,
        modalRelated: HTMLElement,
      },
      requiredMFA: false,
      showMessageExceededFails: false,
      isMaxResendFails: false,
      requiredPasswordExpired: false,
    };
  },
  created() {
    localStorage.setItem("alertMoment", JSON.stringify(this.alertMoment));
    this.user = new User();
    this.mfaClient = new MfaClient();
    this.authClient = new Auth();
  },
  mounted() {
    this.alertMoment = JSON.parse(localStorage.getItem("alertMoment"));
    if (this.getJwtExpired) {
      var ComponentClass = Vue.extend(Alert);
      if (this.alertMoment) {
        this.errorMessage(this.$t("message.login_jwt_expired"));
      }
      this.$store.dispatch("setJwtExpired", { jwtExpired: false });
    }
  },
  computed: {
    ...mapGetters(["getJwtExpired"]),
  },
  methods: {
    getVersion() {
      return "(" + VersionSichern.trim() + ")";
    },
    submitEmailValidation() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.buttonSendEnabled = !this.buttonSendEnabled;
          let that = this;

          this.user
            .changeEmail(that.password, that.emailValidation)
            .then((response) => {
              if (response.data.results.data[0]) {
                this.$store.dispatch("setUser", {
                  user: Object.assign({}, that.username, {
                    mail: that.emailValidation,
                  }),
                });
                localStorage.setItem(
                  "user",
                  JSON.stringify(
                    Object.assign(
                      {},
                      JSON.parse(localStorage.getItem("user")),
                      { mail: that.emailValidation }
                    )
                  )
                );
                this.isFromLogin = false;
                this.setLaunchEmailValidation(false);
                this.getRequiredValidationMFA(true);
              }
              this.buttonSendEnabled = true;
            })
            .catch((error) => {
              let response = error.response.data;
              this.form.error = response.results.data[0];
            });
        }
      });
    },
    changeForgetPass() {
      this.forgetpass = !this.forgetpass;
    },
    changeFirstLogin() {
      this.firstlogin = !this.firstlogin;
    },
    getJwt(value) {
      this.jwt = value;
    },
    getUser(value) {
      this.username = value;
    },
    getPassword(value) {
      this.password = value;
    },
    getFirstLoginToken(value) {
      this.firstLoginToken = value;
    },
    getFirstLoginEmail(value) {
      this.firstLoginEmail = value;
    },
    getPasswordPolicies(value) {
      this.PasswordPolicies = value;
    },
    getUsersRelated(value) {
      this.usersRelated = value;
    },
    getLoginEmailValidation(value) {
      this.emailValidation = value;
      this.emailValidationEmpty = value != "" ? false : true;
    },
    setLaunchEmailValidation(value) {
      this.launchEmailValidation = value;
      this.isFromLogin = false;
      this.buttonSendEnabled = true;
    },
    closeModalAndSession(value) {
      if (value) {
        this.logout();
      }
      $("#switch-user").modal("toggle");
    },
    async logout() {
      await this.authClient.logout();
      localStorage.actions = null
      localStorage.jwt = null;
      localStorage.user = null;
      await axios
        .post(location.origin + `/salir`, null, { withCredentials: true })
        .then(async () => {
          clearInterval(this.keepAliveInterval);
          await this.$store.dispatch("resetStore");
          await this.$router.push("/login");
        });
    },
    keepSessionAlive() {
      const TIMEOUT = 60000; // 1 minute
      this.keepAliveInterval = setInterval(() => {
        const token = localStorage.getItem('jwt');
        const config = token ? {
          headers: {
            Authorization: `Bearer ${token}`
          }
        } : {};
        axios
          .get(location.origin + `/keepalive`, config)
          .then((response) => {
            //Nothing to do
          })
          .catch((err) => console.log(`Error: ${err}`));
      }, TIMEOUT);
    },
    errorMessage(msg) {
      const ComponentClass = Vue.extend(Alert);
      const instance = new ComponentClass({
        propsData: {
          role: "danger",
          title: "Error",
          message: this.$t("message.error_" + msg),
        },
      }).$mount();
      this.$refs.alert.appendChild(instance.$el);
    },
    getRequiredValidationMFA(dataMFA) {
      if (dataMFA) {
        this.requiredMFA = true;
      }
    },
    exceededFailsAuthMFA(valueExceededFails) {
      this.isMaxResendFails = valueExceededFails === "maxResendFails";
      this.showMessageExceededFails = true;
      this.requiredMFA = false;
    },
    hiddenRequiredMFA() {
      this.buttonSendEnabled = !this.buttonSendEnabled;
      this.requiredMFA = false;
      this.showMessageExceededFails = false;
      this.launchEmailValidation = false;
      localStorage.jwt = null;
      this.$store.dispatch("setJwt", { token: null });
    },
    passwordExpired() {
      this.requiredPasswordExpired = true;
    },
    hiddenPasswordExpiredTemplate() {
      this.requiredPasswordExpired = false;
    },
  },
};
</script>

<style scoped lang="scss">
@import "./login.scss";
@import "./login-modern.scss";

.mfa-text {
  font-family: Roboto;
  font-style: normal;
}

.swal2-popup .swal2-content {
  font-size: 1.6em !important;
}
</style>
